module.exports = __webpack_public_path__ + "media/images/get-involved/isac-69c3ad5922b1ac421d1daeab6165c0f5.svg";